import OriginalRangeSlider from 'react-range-slider-input';
import './range-slider.scss';

export const RangeSlider = (props) => {
  return <OriginalRangeSlider {...props} />;
};
